"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attemptApiRequest = void 0;
const fluture_1 = require("fluture");
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const monet_1 = require("monet");
const perimeterX_1 = __importDefault(require("../perimeterX"));
const fluture_utils_1 = require("../utils/fluture-utils");
/**
 * Make a request to the given URL with the provided options.
 *
 * Options are automatically augmented with any required headers needed for interacting with the API.
 *
 * Automatically handles response code verification by checking that the result is an OK status, and extracts the
 * response body for convenience. In addition, handles any PerimeterX block responses accordingly.
 *
 * @param url The request URL.
 * @param options Options for the request.
 */
const attemptApiRequest = (url, options) => {
    const requestOptions = {
        ...options,
        headers: {
            ...commonHeaders,
            ...options.headers
        }
    };
    return (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(url, requestOptions))
        .pipe(fluture_utils_1.verifyResponse)
        .pipe((0, fluture_1.chain)(fluture_utils_1.attemptBody))
        .pipe((0, fluture_1.map)(monet_1.Maybe.fromNull))
        .pipe((0, fluture_1.chainRej)(perimeterX_1.default));
};
exports.attemptApiRequest = attemptApiRequest;
const commonHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
};
//# sourceMappingURL=ecommApi.js.map